import { ReactElement } from 'react'
import { TableWrapper, TableHeader, PageWrapper } from '../../../../components'
import Table from 'react-bootstrap/Table'
import { newlyAddedTestTableHeader } from './const'
import { TableRow, StatusHandler } from './subcomponents'
import UserAction from '../../User/UserAction'
import { FormBackWrapper } from '../../User/subcomponents'

const AssignedTest = (): ReactElement => {
  return (
    <PageWrapper>
      <FormBackWrapper>
        <TableWrapper>
          <Table size="sm" responsive="sm">
            <TableHeader>
              <TableRow>
                {newlyAddedTestTableHeader?.map((header, index) => (
                  <th key={`test-listing-header-${index}`}>{header}</th>
                ))}
              </TableRow>
            </TableHeader>
            <tbody>
              <td>{'Test type'}</td>
              <td>{'Test name'}</td>
              <td>{'Institute name'}</td>
              <td>{'Branch name'}</td>
              <td>{'Batch name'}</td>
              <td>{'Course name'}</td>
              <td>
                <StatusHandler onChangeHandler={() => { }} onSchedule={() => { }} />
              </td>
              <td>
                <UserAction
                  handleNewUserSelect={() => { }}
                  handleDelete={() => { }}
                />
              </td>
            </tbody>
          </Table>
        </TableWrapper>
      </FormBackWrapper>
    </PageWrapper>
  )
}

export default AssignedTest
